import { render, staticRenderFns } from "./dashboardPage.vue?vue&type=template&id=14bddb7b"
import script from "./dashboardPage.vue?vue&type=script&lang=js"
export * from "./dashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports